"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = require("@react-google-maps/api");
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const components_common_map_pin_1 = require("@hotelplan/components.common.map-pin");
const MapRadiusSearch_constants_1 = require("./MapRadiusSearch.constants");
const MapRadiusSearch_styled_1 = require("./MapRadiusSearch.styled");
const PinOfInterest_1 = __importDefault(require("./PinOfInterest"));
function MapRadiusSearchAutocomplete(props) {
    const { value: { place, radius = MapRadiusSearch_constants_1.DEFAULT_RADIUS } = {}, onChange, centerLocation = true, showPinOfInterest = true, pinOfInterestIcon, } = props;
    const map = (0, api_1.useGoogleMap)();
    const [t] = (0, next_i18next_1.useTranslation)('map');
    const inputRef = (0, react_1.useRef)(null);
    const autocomplete = (0, react_1.useRef)(null);
    function onChangePlace() {
        var _a;
        const nextAutocompletePlace = (_a = autocomplete.current) === null || _a === void 0 ? void 0 : _a.getPlace();
        if (!nextAutocompletePlace)
            return;
        const { name, geometry } = nextAutocompletePlace;
        if (geometry) {
            centerLocation && (map === null || map === void 0 ? void 0 : map.setCenter(geometry.location));
            onChange({
                place: {
                    name,
                    coordinates: (0, components_common_map_pin_1.mapLatLngToCoordinates)(geometry.location),
                },
                radius,
            });
        }
        else {
            onChange({
                place: undefined,
                radius,
            });
        }
    }
    function onChangeRadius(nextValue) {
        try {
            onChange({
                place,
                radius: parseFloat(nextValue),
            });
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error(`Could not change radius`, e);
        }
    }
    function onFocus(e) {
        e.target.value = (place === null || place === void 0 ? void 0 : place.name) || '';
    }
    function onLoad(ac) {
        autocomplete.current = ac;
        if (place === null || place === void 0 ? void 0 : place.name) {
            inputRef.current.value = place.name;
        }
    }
    (0, react_1.useEffect)(function clearInputOnReset() {
        if (!place && inputRef.current) {
            inputRef.current.value = '';
        }
    }, [place]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(MapRadiusSearch_styled_1.MapAutocompleteControls, null,
            react_1.default.createElement(api_1.Autocomplete, { onLoad: onLoad, onPlaceChanged: onChangePlace, className: 'map-autocomplete' },
                react_1.default.createElement(MapRadiusSearch_styled_1.MapAutocompleteInput, { inputRef: inputRef, placeholder: t('map:map.places.placeholder'), onFocus: onFocus })),
            react_1.default.createElement(MapRadiusSearch_styled_1.RadiusInput, { options: MapRadiusSearch_constants_1.radiusOptions, value: String(radius), onChange: onChangeRadius })),
        showPinOfInterest && place && (react_1.default.createElement(PinOfInterest_1.default, { key: place.name, coordinates: place.coordinates, name: place.name, iconName: pinOfInterestIcon }))));
}
exports.default = MapRadiusSearchAutocomplete;
//# sourceMappingURL=MapRadiusSearchAutocomplete.js.map